<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import ModalHeader from "./ModalHeader.vue";
import flagIcon1 from "../../../static/assets/images/flag-1.svg";
import flagIcon2 from "../../../static/assets/images/flag-2.svg";
import flagIcon3 from "../../../static/assets/images/flag-3.svg";
export default {
  name: "NotesModal",
  components: {
    ModalHeader,
  },
  data() {
    return {
      flagIcon1,
      flagIcon2,
      flagIcon3,
    };
  },
  computed: {
    show: {
      set(value) {
        this.$store.commit(`${this.currentType}/notesOpened`, value);
      },
      get() {
        return this.notesOpened;
      },
    },
    flag_internal_notes: {
      set(value) {
        this.$store.commit(`${this.currentType}/setActivityField`, {
          fieldName: "flag_internal_notes",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.flag_internal_notes;
        }
        return "";
      },
    },
    currentActivity() {
      return this.$store.getters[`${this.currentType}/currentActivity`];
    },
    notesOpened() {
      return this.$store.getters[`${this.currentType}/notesOpened`];
    },
    currentType() {
      const url = this.$route.path.split("/")[1];
      if (this.$route) {
        if (url == "update-warmup" || this.$route.path == "/create-warmup") {
          return "warmups";
        } else if (
          url == "update-stretch-flow" ||
          this.$route.path == "/create-stretch-flow"
        ) {
          return "stretchflows";
        }
      }
      return "workouts";
    },
  },
  methods: {
    save() {
      this.$store
        .dispatch(`${this.currentType}/updateActivity`, this.$route.params.id)
        .then(
          (res) => {
            // this.makeToast("success", "Success", `Succesfully saved.`);
            this.$store.commit(`commons/setSavingForm`, "Saved");
            this.$store.commit(`${this.currentType}/setOpenedNotes`, false);
          },
          (error) => {
            console.log(
              error
            );
          }
        );
    },
    close() {
      this.$store.commit(`${this.currentType}/setOpenedNotes`, false);
    },
    updateFlag(flag) {
      this.$store.commit(`${this.currentType}/setCurrentFlag`, flag);
    },
    onHidden(e) {
      this.$store.commit(`${this.currentType}/setOpenedNotes`, false);
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
  },
};
</script>
<style lang="scss">
.cancel {
  border: 1px solid #e0e1e2 !important;
  background: #e0e1e2 !important;
  color: #00000099 !important;
  &:hover {
    background: #5a6268 !important;
    color: #fff !important;
  }
}
#notesModal {
  .modal-header {
    border: 0;
    text-align: center;
    padding: 0;
    border: 0 !important;
    padding: 0 !important;
    padding-top: 50px !important;
    h2 {
      font-size: 32px;
      margin: 0;
    }
  }

  .modal-body {
    padding: 0 !important;
    .content {
      h3 {
        color: rgba(51, 51, 51, 0.87) !important;
        font-size: 20px !important;
        font-family: "Lato-Regular" !important;
        text-align: center;
        padding: 15px 0 20px;
      }
      p {
        font-size: 16px;
        font-family: "Lato-Regular";
        color: #000000de;
      }
      ul {
        padding: 0;
        li {
          display: inline-block;
          padding: 14px 25px;
          border: 1px solid #dedede;
          border-radius: 4px;
          margin-right: 20px;
          background: #fff;

          &.active {
            border: 1px solid #3f9698;
            background: #effdff;
          }
          img {
            width: 25px;
            height: 25px;
          }
        }
      }

      textarea {
        max-height: 200px;
        min-height: 200px;
      }
    }
  }

  .modal-footer {
    border: 0 !important;
    padding: 0 !important;
    padding-bottom: 50px !important;
  }
}
</style>

<template>
  <b-modal
    @hidden="onHidden"
    v-model="show"
    id="notesModal"
    size="lg"
    :close-on-backdrop="false"
    :close-on-esc="false"
  >
    <template #modal-header="{ close }">
      <modal-header :close="close"></modal-header>
    </template>
    <div class="content px-5">
      <h3>
        Leave a note and / or flag this to make sure you can keep track of it.
      </h3>
      <b-form-group label="">
        <b-form-textarea
          id="wardrobe_and_hair"
          placeholder="Enter your note here..."
          rows="3"
          max-rows="6"
          v-model="flag_internal_notes"
        ></b-form-textarea>
      </b-form-group>
      <p>Do you want to flag this workout?</p>
      <ul>
        <li
          :class="currentActivity.flag_intensity == 1 ? 'active' : ''"
          @click="updateFlag(1)"
        >
          <img :src="flagIcon1" />
        </li>
        <li
          :class="currentActivity.flag_intensity == 2 ? 'active' : ''"
          @click="updateFlag(2)"
        >
          <img :src="flagIcon2" />
        </li>
        <li
          :class="currentActivity.flag_intensity == 3 ? 'active' : ''"
          @click="updateFlag(3)"
        >
          <img :src="flagIcon3" />
        </li>
      </ul>
    </div>
    <template #modal-footer>
      <div class="text-right px-5">
        <b-button variant="secondary cancel px-4 py-3" @click="close()"
          >CANCEL</b-button
        >
        <b-button variant="primary px-4 py-3 ml-3" @click="save()"
          >SAVE
        </b-button>
      </div>
    </template>
  </b-modal>
</template>